export default {
  SET_DISTRICT: function (state, payloads) {
    state.district = payloads;
  },
};
